<template>
    <div class="row">
        <input-select class="col-10" label="Tipo" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-radio class="col-2" label="Publicada?" ref="publicada" required :options="options.simnao" v-model="form.publicada" />
        <input-date-time class="col-12 col-md-3" :label="`${form.publicada == 'S' ? 'Data da publicação' : 'Data de previsão'}`" ref="data" required v-model="form.dataPublicacao"/>
        <input-text class="col-12 col-md-9" label="Nome da publicação" placeholder="Máximo 50 caracteres" :max-length="50" ref="nome" required v-model="form.nomeDaPublicacao"/>
        <input-textarea class="col-12" label="Titulo" ref="titulo" placeholder="Máximo 200 caracteres" :max-length="200" required v-model="form.titulo"/>
        <input-text class="col-12" label="Link" ref="link" placeholder="Máximo 50 caracteres" :max-length="50" required v-model="form.link"/>
        <input-text class="col-12 col-md-6" label="Pais" placeholder="Máximo 30 caracteres" :max-length="30" ref="pais" required v-model="form.pais"/>
        <input-text class="col-12 col-md-6" label="Cidade" placeholder="Máximo 30 caracteres" :max-length="30" ref="cidade" required v-model="form.cidade"/>

        <div class="col-12">
            <upload v-if="!form.nomeArquivoAWS"
                id="producao_cientifica" 
                tituloArquivo="Arrastar PDF" 
                selecioneArquivo="Selecionar o PDF"  
                type=".pdf" 
                
                :arquivo-download="form.conteudoBase64"
                :arquivo-download-nome="form.nomeArquivoAWSUP"

                @upload="(file, nomeArquivo)=> {                   
                    form.conteudoBase64 = file;
                    form.nomeArquivoAWSUP = nomeArquivo;
                    this.$forceUpdate();
                }" 
            />

            <template v-if="form.nomeArquivoAWS">
                <div>
                    Arquivo
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="() =>{this.form.nomeArquivoAWS = null;}" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="() => {this.$emit('downloadArquivo', this.form.id);}" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeArquivoAWS}}
                        </div>
                    </div>
                </div>
            </template>

        </div>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputRadio from "@/components/inputs/InputRadio.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";
import InputDateTime from "@/components/inputs/InputDateTime.vue";
import Upload from "@/components/upload/Upload.vue";

import helpers from "@/common/utils/helpers";

import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "ModalCapacitacaoTecnologica",
    mixins: [FormMixin],
    components: {
        InputSelect,
        InputText,
        InputTextarea,
        InputDateTime,
        Upload,
        InputRadio,
    },    
    data : () => ({
        form : {
            id: null,
            tipo: null,
            publicada: 'N',
            dataPublicacao: null,
            nomeDaPublicacao: null,
            titulo: null,
            link: null,
            pais: null,
            cidade: null,
            conteudoBase64: null,
            nomeArquivo: null,
        },
        options : {
            tipo : helpers.getTiposProducaoCientifica(),
            simnao : [
                {value: 'S', text: "Sim"},
                {value: 'N', text: "Não"}
            ]
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);

            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);
            form.dataPublicacao = helpers.formatarDataBr(form.dataPublicacao);

            this.form = form;
        },
    }
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>